@if (recordData) {
  <mat-card appearance="outlined" class="summary-card">
    <div class="summary-card__top">
      <div class="summary-card__header">
        <div class="summary-card__header-row">
          <div class="summary-card__title" i18n="@@home.summaryCard.title.measuredDataOverview">
            <span class="material-icons-outlined">description</span>
            計測データ概要
          </div>
          @if (shouldShowMeasurementTime()) {
            <div class="summary-card__date" i18n="@@home.summaryCard.label.measurementDate">計測日: {{ recordData?.data.createdAt | localDatetime }}</div>
          }
        </div>
        <div class="summary-card__info-row">
          <div class="summary-card__info-left">
            <span class="info-chip info-chip--primary" i18n="@@home.summaryCard.label.protocol">プロトコル: {{ recordData?.data.recordTypeView }}</span>
            @if (shouldShowMeasurementTime()) {
              <span class="info-chip" i18n="@@home.summaryCard.label.measurementTime">計測時間: {{ recordData?.data.wavDuration | millisecondsToTime }}</span>
            }
          </div>
        </div>
      </div>
    </div>

    <mat-card-content class="summary-card__body">
      @if (shouldShowMeasurementSummary()) {
        <div class="summary-card__metrics twin-counter">
          <div class="twin-counter__item twin-counter__item--left">
            <div class="twin-counter__label" i18n="@@home.summaryCard.label.swallowCount">嚥下回数</div>
            <div class="twin-counter__value">{{ recordData?.data.numOfSwallowings }}</div>
          </div>
          <div class="twin-counter__divider"></div>
          <div class="twin-counter__item twin-counter__item--right" [ngClass]="{'is-muted': !shouldShowCoughCount()}">
            <div class="twin-counter__label" i18n="@@home.summaryCard.label.coughCount">咳嗽・ムセ</div>
            <div class="twin-counter__value">
              @if (shouldShowCoughCount()) {
                {{ recordData?.data.numOfCoughs }}
              } @else {
                -
              }
            </div>
          </div>
        </div>
      }

      @if (mwstScoreItems.length) {
        <div class="summary-card__score">
          <div class="score__title" i18n="@@home.summaryCard.label.score">評点</div>
          <div class="score__list">
            @for (item of mwstScoreItems; track item.value) {
              <div class="score__item" [ngClass]="{ 'is-checked': item.checked }">
                <span class="material-icons-outlined score__icon" aria-hidden="true">
                  {{ item.checked ? 'check_box' : 'check_box_outline_blank' }}
                </span>
                <div class="score__body">
                  <div class="score__label" i18n="@@home.summaryCard.label.scoreValue">評点{{ item.value }}</div>
                  <div class="score__desc">{{ item.description }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (hasGostSummary()) {
        <div class="summary-card__gost">
          <div class="summary-card__gost-grid">
            @for (card of gostSummaryCards; track card.key) {
              <div class="gost-mini-card">
                <div class="gost-mini-card__header">
                  <div class="gost-mini-card__title">{{ card.title }}</div>
                  @if (card.key !== 'fils') {
                    <button type="button" class="gost-mini-card__chip" i18n="@@home.summaryCard.button.detail" (click)="onSummaryDetailClick(card.key)">詳細</button>
                  }
                </div>
                <div class="gost-mini-card__metrics" [ngClass]="{ 'metrics-two': card.key === 'fils' || card.key === 'sc' }">
                  @if (card.key === 'fils') {
                    <div class="metric">
                      <span class="metric__label" i18n="@@home.summaryCard.label.estimatedFils">推定FILS</span>
                      <span class="metric__value">{{ card.score ?? '-' }}</span>
                    </div>
                    <div class="metric">
                      <span class="metric__label" i18n="@@home.summaryCard.label.estimatedRecommendation">推定おすすめ</span>
                      <span
                        class="metric__value metric__value--nowrap metric__value--recommend"
                        [ngClass]="getRecommendSizeClass(card.recommendation)"
                        [matTooltip]="card.recommendation ?? '-'"
                        matTooltipClass="tooltip-wrap"
                      >
                        {{ card.recommendation ?? '-' }}
                      </span>
                    </div>
                  } @else {
                    @if (card.key === 'sc') {
                      <div class="metric">
                        <span class="metric__label" i18n="@@home.summaryCard.label.maxVolume">最大飲水量</span>
                        <span class="metric__value metric__value--nowrap">{{ card.maxVolume ? (card.maxVolume + ' mL') : '-' }}</span>
                      </div>
                      <div class="metric">
                        <span class="metric__label" i18n="@@home.summaryCard.label.abnormal">異常</span>
                        <span
                          class="metric__value"
                          [ngClass]="{ 'metric__value--danger': card.hasAbnormal }"
                          [style.color]="card.hasAbnormal ? '#e53935' : null"
                        >
                          {{ card.hasAbnormal ? abnormalPresentLabel : abnormalAbsentLabel }}
                        </span>
                      </div>
                    } @else {
                    <div class="metric">
                      <span class="metric__label" i18n="@@home.summaryCard.label.totalScore">総スコア</span>
                      <span class="metric__value">{{ card.score ?? '-' }}</span>
                    </div>
                    <div class="metric">
                      <span class="metric__label" i18n="@@home.summaryCard.label.attentionCount">注意項目数</span>
                      <span
                        class="metric__value"
                        [ngClass]="{ 'metric__value--warn': card.abnormalCount > 0 }"
                        [style.color]="card.abnormalCount > 0 ? '#f59e0b' : null"
                      >
                        {{ card.abnormalCount }}
                      </span>
                    </div>
                  }
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </mat-card-content>

    <div class="summary-card__footer">
      @if (shouldShowAiDisclaimer()) {
        <div class="summary-card__note summary-card__note--footer" i18n="@@home.summaryCard.note.aiDisclaimer">
          嚥下回数や咳嗽回数はAI推定であり、必ずしも正しいとは限りません。重要な情報は確認するようにしてください。
        </div>
      }
      <div class="footer-right">
        <div class="footer-row">
          <span class="info-inline" i18n="@@home.summaryCard.label.measurer">計測者: {{ recordData?.meta.measurer.lastName }} {{ recordData?.meta.measurer.firstName }}</span>
          <span class="info-inline" i18n="@@home.summaryCard.label.section">セクション: {{ recordData?.meta.location.sectionName }}</span>
        </div>
        <div class="footer-id" i18n="@@home.summaryCard.label.dataId">データID: {{ recordData?.id }}</div>
      </div>
    </div>
  </mat-card>
}
